import { ResizeBackgroundImportState } from "../types";

export const reset = (state: ResizeBackgroundImportState) => {
    state.importComplete = false;
    state.isImporting = false;
    state.progress = undefined;
    state.fileSize = 0;
    state.task = undefined;
};
